import React, {useEffect} from "react";
import { Modal, Form, Input, Button, TreeSelect ,Select, Grid, Tooltip} from "antd";
import "./Waitlist";
import PosService from "../../../services/PosService";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Option } = Select;
const {useBreakpoint} = Grid


export default function AddWaitlist({ data, ...props }) {
  const formRef = React.createRef();
  const [form] = Form.useForm();
  const history = useHistory();
  const adminRestaurant = useSelector((state) => state.admin);
  const screens = useBreakpoint();


  const onFinish = async(values) => {
    values.num_people = Number(values.num_people)
    values.est_wait_time_min = Number(values.est_wait_time_min)
    const res = await PosService.addWaitlist( values)
    if(res){
      props.closeModal(false)
      history.push(`/pos/waitlist`);
    }
  };

  return (
    <Modal
      title={"Add Party"}
      open={props.modalOpen}
      className={screens.md ? "add-waitlist-modal" : "add-waitlist-modal-mobile"}
      footer={null}
      onCancel={() => props.closeModal(false)}
    >
      <Form initialValues={{sections: data?.section, name: data?.name}}  ref={formRef} form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="name" label="Name">
          <Input  />
        </Form.Item>

        
        <Form.Item name="num_people" label="No. Of Guests">
        <Input defaultValue={data?.code} type="number" />
        </Form.Item>
        <Form.Item name="est_wait_time_min" label={
          
          <div> Est wait time in min
          <Tooltip title="Estimated service time.">
        <InfoCircleOutlined style={{ color: '#C32340', marginLeft: 8, cursor: 'pointer' }} />
      </Tooltip>
      </div>
          
        }>
        <Input defaultValue={data?.code} type="number" />
        </Form.Item>

<Form.Item name="email" label="Email">
          <Input defaultValue={data?.code}  />
        </Form.Item>

        <Form.Item name="phone" label="Phone">
        <Input defaultValue={data?.code}  />
        </Form.Item>

        <Form.Item className="button-form">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
